
export { default as identity } from "./identity.js"
export { default as isEmpty } from "./isEmpty.js"
export { default as pathOr } from "./pathOr.js"